export const templateComps = {
  confirmModal: {
    cancel: "Cancelar",
    delete: "Excluir",
  },
  channexIncident: {
    kicker: "Aviso importante",
    brandTitle: "Incidente externo",
    closeLabel: "Fechar aviso",
    subtitle:
      "Estamos monitorando a situação e revisaremos a sincronização assim que o serviço for restabelecido.",
    title:
      "Incidente geral na conexão com Booking / Airbnb / gerenciador de canais externo",
    lead: "Olá, estamos detectando um incidente geral com nosso provedor externo de sincronização de OTA.",
    text: "Este incidente afeta a API deles e pode atrasar a sincronização de reservas, disponibilidade e bloqueios de datas.",
    note: "Assim que a conexão for restabelecida, revisaremos a sincronização de dados para verificar reservas, disponibilidade e bloqueios de datas.",
    textLast:
      "Nós da WA Checkin revisaremos a sincronização assim que o serviço voltar a funcionar.",
    button: "Entendi",
  },
  notificationsNav: {
    title: "Notificações",
    recent: "recentes",
    emptyTitle: "Nenhuma notificação",
    emptyText:
      "Quando algo importante acontecer com suas reservas, aparecerá aqui.",
    seeAll: "Ver todas as notificações",
    meta: {
      t1: { status: "Nova", category: "reserva" },
      t2: { status: "Atualizada", category: "reserva" },
      t3: { status: "Cancelada", category: "reserva" },
      t4: { status: "Concluído", category: "check-in" },
      t5: { status: "Solicitado", category: "serviço" },
      t6: { status: "Recebida", category: "solicitação" },
      t7: { status: "Aprovada", category: "solicitação" },
      t8: { status: "Rejeitada", category: "solicitação" },
      t9: { status: "Confirmado", category: "pagamento" },
      t10: { status: "Aguardando pagamento", category: "pagamento pendente" },
      t11: { status: "Atribuir quarto", category: "reserva" },
      t12: { status: "Falha no envio", category: "check-in" },
      t13: { status: "Não enviado", category: "registro de viajante" },
      t15: { status: "Ativa", category: "assinatura" },
      default: { status: "Aviso", category: "sistema" },
    },
    typeLabel: {
      t1: "NOVA RESERVA",
      t2: "RESERVA ATUALIZADA",
      t3: "RESERVA CANCELADA",
      t4: "CHECK-IN",
      t5: "SERVIÇO",
      t6: "SOLICITAÇÃO",
      t7: "SOLICITAÇÃO APROVADA",
      t8: "SOLICITAÇÃO REJEITADA",
      t10: "AGUARDANDO PAGAMENTO",
      t11: "ATRIBUIR QUARTO",
      t12: "FALHA NO ENVIO",
      t13: "REGISTRO DE VIAJANTE",
      t15: "ASSINATURA ATIVA",
      default: "NOTIFICAÇÃO",
    },
  },
};
